import instanceAPI from 'services/apis/axiosconfig';

export const getCarouselFooterItems = () => {
  const request = instanceAPI.get('/public/get-carousel-footer');
  return request.then((res) => ({
    ...res,
    data: {
      results: res.data.elements,
    },
  }));
};
